export default __webpack_public_path__ + "static/vacations-hero-fallbackposter-5f6dfefde4324a8e097cd8c5da246d08.jpg";